import { BaseStatementPagePath } from "app/core/workflow/page-path/statement-page-path/base-statement-page.path";

export class AdditionalOptionsSpouseComponentPath extends BaseStatementPagePath {
  public static path(): string {
    return "statement/:statementId/spouse/:spouseId/additional-options/:step";
  }

  public static pathWithoutStep(): string {
    return "statement/:statementId/spouse/:spouseId/additional-options";
  }

  public static regex(step?: number): RegExp {
    return this.componentRegex(this.path(), null, null, step);
  }
}
